import React from 'react';
import Sec1event from '../sections/sec-event.jsx';



const Event = () => {
    return ( 
        <>
            <section className='home'>
                <div className='circle-dec-sec1'></div>
                <div className='circl2-sec1-dec'></div>
               <Sec1event />
            </section>
        </>
     );
}
 
export default Event;